import { render, staticRenderFns } from "./BlogShow.vue?vue&type=template&id=0ba09acc&scoped=true"
import script from "./BlogShow.vue?vue&type=script&lang=js"
export * from "./BlogShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba09acc",
  null
  
)

export default component.exports